module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABNklEQVRYR+2XsW6DMBCG7YEJqaztS0R5jw6VGNhZfPAImdJOeQXbCztbKvEcrfoSyRyJCQlHHpCqgKOzA5GRzIb5sb/7fT4OSjy5qCccZH0gUsqtUuoD6yCl9MgY+0XrsUIhxJ4Q8onVay0AfGH16K2xdaTv+++yLH9mB8FO6KobOWIbue3CptwZgTjkgi3LZO483RFT7qCT1TZsW/06QIQQSkfGGHuxjfC/Xkp50fcAYAz8riNTIHVdb9q2fY/juMmy7G9Y0DSuny8CUlXVruu6XRRFhzzPDwOIaTyA3DoVHAmOhFPjTR0ZKmiSJE2apqPKeju+2PF1+eYsUuIDiBdtAOf8RCl9ddmOiXfOAPBmmutuP8I51392/FEYpdSZEFIURXF0ApnJCdQ06+hZUaHMJPLGkSuRiG4ywIgT8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-delete.png
// module id = /Oe9
// module chunks = 4